import { SearchModelItems } from '@app/entities/models/search/search-model-items.model';

export class SearchModelCollection {
  page!: number;
  pageSize!: number;
  totalItems!: number;
  items!: SearchModelItems[];
  totalPages!: number;
}
